(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function ($) {

  /*
  ==========================================================================
  helium file field
  ==========================================================================
  */
  var heliumSetFileUploader = function heliumSetFileUploader(button, field) {
    var btnTitle, tempFrame, title, typeInput;
    title = 'Select a File';
    btnTitle = 'Use File';
    typeInput = button.data('type');
    tempFrame = wp.media({
      title: title,
      button: {
        text: btnTitle
      },
      library: {
        type: typeInput
      },
      multiple: false
    });
    tempFrame.on('select', function () {
      var attachment, link;
      attachment = tempFrame.state().get('selection').first().toJSON();
      link = '<a target="_blank" href="' + attachment.url + '">' + attachment.url + '</a>';
      $(field).val(attachment.id);
      $(button).parent().next().html(link);
    });
    wp.media.frames.file_frame = tempFrame;
    wp.media.frames.file_frame.open();
    return false;
  };
  $(document).on('click', '.he-file-picker-button', function () {
    var field;
    field = $(this).parent().prev();
    heliumSetFileUploader($(this), field[0]);
  });

  /*
  ==========================================================================
  color fields
  ==========================================================================
  */
  $(document).on('change', '.he-background-color-field select', function () {
    var wrapper = $(this).parents('.he-background-color-field'),
        textColorField = wrapper.siblings('.he-text-color-field');

    if ($(this).val() == 'dark') {
      textColorField.hide();
    } else {
      textColorField.show();
    }
  });

  /*
  ==========================================================================
  04. Text Media Split
  ==========================================================================
  */
  $(document).on('change', '.he-media-type-field input', function () {
    var wrapper = $(this).parents('.he-media-type-field'),
        images = wrapper.siblings('.he-images-field'),
        video = wrapper.siblings('.he-video-fields');

    if ($(this).prop('checked') == true) {
      if ($(this).val() == 'images') {
        images.show();
        video.hide();
      } else {
        images.hide();
        video.show();
      }
    }
  });

  /*
  ==========================================================================
  06. Form
  ==========================================================================
  */
  $(document).on('change', '.he-form-type-field input', function () {
    var wrapper = $(this).parents('.he-form-type-field'),
        hubspot = wrapper.siblings('.he-hubspot-form-field'),
        gform = wrapper.siblings('.he-gform-field'),
        embed = wrapper.siblings('.he-form-embed-field');
    if ($(this).prop('checked') == true) {
      if ($(this).val() == 'Hubspot') {
        hubspot.show();
        gform.hide();
        embed.hide();
      } else if ($(this).val() == 'Gravity Form') {
        hubspot.hide();
        gform.show();
        embed.hide();
      } else {
        hubspot.hide();
        gform.hide();
        embed.show();
      }
    }
  });

  /*
  ==========================================================================
  init tinymce on builder/repeater add
  ==========================================================================
  */
  TypeRocket.repeaterCallbacks.push(function ($template) {
    var $tinymce = $template.find('.wp-editor-area');
    $tinymce.each(function () {
      tinyMCE.execCommand('mceAddEditor', false, $(this).attr('id'));
    });
  });
});

},{}]},{},[1]);
